import React from 'react';
import TitleView from './titleview';

class Message extends React.Component {
	render() {
		return (
			<div>
				<TitleView title={this.props.question.question_text}/>
			</div>
		);
	} 
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/message.jsx